import React from "react";
import { CardData } from "@/components/layout/element-layout/grid-layout/GridLayout";
import { TypeItem, deleteType } from "@/lib/stores/typesStore";
import VariablesWidget from   "@/components/cards/widgets/VariablesWidget";
import VariableWizard from   "@/components/wizards/variables/VariableWizard";
import { ItemTypeConfig } from "./types";
import { variablesDataSource } from "@/lib/dataSources/sources/variables";

export const variablesConfig: ItemTypeConfig = {
  type: "variables",
  title: "Variables",
  pageSection: "variables",
  eventName: "addVariable",
  emptyStateTitle: "No Variables",
  emptyStateDescription:
    "No variables found for this game. Create your first variable to get started.",
  noGameSelectedDescription:
    "Please select a game to view its variables.",

  /**
   * Transform raw items to CardData using the DataSource transformer
   * This delegates to variablesDataSource.transformers.toCard() for single source of truth
   */
  transformData: (
    items: TypeItem[],
    tags: any[],
    getUserNameById: (id: string) => string,
    glossaryBlueprints?: any[]
  ): CardData[] => {
    if (!items || !Array.isArray(items)) {
      console.warn("transformData: items is not an array:", items);
      return [];
    }
    
    // Use DataSource transformer with context
    const cards = variablesDataSource.transformers.toCard?.(items, {
      tags,
      blueprints: glossaryBlueprints || [],
      getUserNameById,
    }) || [];
    return cards;
  },

  renderCard: (card: CardData, tags: any[]) => {
    return (
      <VariablesWidget
        id={card.id}
        gameId={card.gameId}
        title={card.title}
        elementType={card.elementType || 'string'}
        elementTypeLabel={card.elementTypeLabel || 'String'}
        elementCount={card.elementCount || 0}
        description={card.description}
        groupName={card.groupName}
        lastUpdate={card.lastUpdate}
        folder={card.folder as string}
        itemType="variables"
        shadowType={card.shadowType}
        shadowColor={card.shadowColor}
        onDelete={card.onDelete}
        onEdit={card.onEdit}
      />
    );
  },

  getWizard: (props: any) => {
    return (
      <VariableWizard
        isOpen={props.isOpen}
        onClose={props.onClose}
        onSuccess={props.onSuccess}
        folderId={props.folderId}
      />
    );
  },

  handleDelete: async (id: string, gameId: string, toast: any) => {
    await deleteType(id, gameId, toast);
  },

  handleCardClick: (card: CardData) => {
    // Navigation handled by hook - will navigate to /variables/:id
  },

  handleAdd: () => {
    // Handled by hook
  },
};
